import { ActionType } from '../../classes/action-type';
import { ICalendarStateAction } from '../interfaces/calendar-state.action';
import { ILazyLoadState, defaultLazyLoadState } from '../interfaces/lazy-load.state';

/**
 * Returns the new search state given a particular action. This where all of the application
 * logic resides.
 */
export default function lazyLoadReducer(state: ILazyLoadState = defaultLazyLoadState, action: ICalendarStateAction) {
    switch (action.type) {
        case ActionType.WaitForImage: {
            if (action.value in state.imageHasLoaded) {
                return state;
            } else {
                let imagesDictionary = { ...state.imageHasLoaded };
                imagesDictionary[action.value] = false;

                return { ...state, imageHasLoaded: imagesDictionary } as ILazyLoadState;
            }
        }
        case ActionType.ImageHasLoaded: {
            let imagesDictionary = { ...state.imageHasLoaded };
            imagesDictionary[action.value] = true;

            return { ...state, imageHasLoaded: imagesDictionary } as ILazyLoadState;
        }
        default:
            return state;
    }
}
